import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const DeleteUserApiImpl = async (userId: string): Promise<Either<ErrorEntity, void>> =>{
    try {
        const relativeUrl = `/users/${userId}`;
        await di.get<HostApi>(HostApiName).remove(relativeUrl);
        return right(undefined);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default DeleteUserApiImpl;